import * as React from 'react';

import { Title } from 'common/components';
import { Glossary, HistoryGL } from 'common/utils/glossary';

const MESSAGE_TYPES = {
  notFoundAnyHistory: HistoryGL.NotFoundAnyHistory,
  otherError: HistoryGL.OtherError
} as const;
export type MESSAGE_TYPES_KEY = keyof typeof MESSAGE_TYPES;

interface Props {
  /** メッセージを表示するか否か */
  show: boolean;
  /** メッセージの種類 */
  messageType?: MESSAGE_TYPES_KEY;
  /** グロッサリ */
  glossary: Glossary;
}

/**
 * 履歴のリストに表示するエラーメッセージのPresentation Component
 */
export const PurchaseHistoryListMessage: React.FC<Props> = ({
  show,
  messageType,
  glossary
}) => {
  const messageText = messageType && glossary.glx(MESSAGE_TYPES[messageType]);
  // 表示するComponentをメモライズ
  const _message = React.useMemo(() => {
    return show && messageType ? (
      <Title type="listMessage" data-test={`${messageType}-message`}>
        {messageText}
      </Title>
    ) : null;
  }, [show, messageType, messageText]);

  return _message;
};
